import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const genericVarianceCell = (boolField: string) => (props: GridCellProps) => {
  const { dataItem } = props;
  const { displayValue } = useGridCellDisplayValue(props);
  return (
    <GridCellBase
      {...props}
      title={displayValue}
      className={dataItem[boolField] ? 'text-[#D9534F] bg-[#d9aa4f33]' : ''}
    >
      <div className={displayValue.startsWith('$') ? 'text-right' : ''}>{displayValue}</div>
    </GridCellBase>
  );
};

export default genericVarianceCell;
